import { LoaderCircle } from "lucide-react";
import { cn } from '@/lib/utils/helpers'

export default function Loading({ children, className }) {
  return (
    <div className={cn("flex items-center justify-center min-h-[500px]", className)}>
      <div className="flex flex-col items-center justify-center">
        <LoaderCircle className="w-12 h-12 animate-spin text-primary" />
      </div>
    </div>
  );
};
